import React, { useContext, useState, useEffect } from "react";
import { ProgressBar, Card, Row, Col } from "react-bootstrap";
import { GlobalContext } from "../Context/GlobalState";
import loaderGif from "../seoimages/aiload.gif";

import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import { basicAuth } from "../utils/Credentials";
const QuotaUsage = () => {
  const { password, username } = basicAuth;
  const base64Credentials = btoa(`${username}:${password}`);
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const [quotas, setQuotas] = useState([]);
  const [quotas1, setQuotas1] = useState([]);
  const [loading, setLoading] = useState(false);
  const generateUUID = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };
  const GetMozQuotaLimit = async () => {
    setTransactionLoaderState(true);
     setLoading(true);
    try {
      const uuid = generateUUID();

      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({ uuid: uuid, type: "0" }),
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Admin/GetMozQuotaLimit`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      const quotaData = data?.result?.quota;

      if (quotaData) {
        const formattedQuota = [
          {
            name: "Moz Api",
            limit: parseInt(quotaData.allotted),
            usage: parseInt(quotaData.used),
            last_reset: new Date(
              parseInt(quotaData.period_reset) * 1000
            ).toLocaleDateString(),
          },
        ];

        setQuotas(formattedQuota);
      }
    } catch (error) {
    } finally {
      setTransactionLoaderState(false);
         setLoading(false);
    }
  };
  const GetMozQuotaLimit1 = async () => {
    setTransactionLoaderState(true);
     setLoading(true);
    try {
      const uuid = generateUUID();

      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({ uuid: uuid, type: "1" }),
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Admin/GetMozQuotaLimit`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to fetch SEO data.");
      }

      const data = await response.json();
      const quotaData = data?.result?.quota;

      if (quotaData) {
        const formattedQuota = [
          {
            name: "Beta Methods",
            limit: parseInt(quotaData.allotted),
            usage: parseInt(quotaData.used),
            last_reset: new Date(
              parseInt(quotaData.period_reset) * 1000
            ).toLocaleDateString(),
          },
        ];

        setQuotas1(formattedQuota);
      }
    } catch (error) {
    } finally {
      setTransactionLoaderState(false);
         setLoading(false);
    }
  };
  useEffect(() => {
    GetMozQuotaLimit();
    GetMozQuotaLimit1();
  }, []);

  return (
    <div
      className="pt-4 m-1"
      style={{
        height: "85vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
      <h5 className="px-0 mb-3">Quota Usage</h5>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
         <img src={loaderGif} alt="Loading..." style={{height:"4rem"}} />

        </div>
      ) : (
      <Row className="pt-0 mt-2">
        {[...quotas, ...quotas1].map((quota, index) => (
          <Col md={4} key={index} className="mb-2 px-1">
            <Card className="p-2 shadow-sm">
              <h5>{quota.name}</h5>
              <p className="text-muted">{quota.name} - Plan Details</p>
              <ProgressBar
                now={(quota.usage / quota.limit) * 100}
                variant="dark"
                style={{ height: ".4rem" }}
              />
              <p className="mt-2">
                {quota.usage} / {quota.limit} Requests used (
                {((quota.usage / quota.limit) * 100).toFixed(0)}%)
              </p>
              <p className="text-muted">📅 Last Reset: {quota.last_reset}</p>

              <div
                className="d-flex align-items-center"
                style={{ justifyContent: "space-between" }}
              >
                {/* <Link to="/Seobix/Subscription">Manage Subscription</Link> */}
                {/* <Link to="/Seobix/Help-support">Report Usage</Link> */}
              </div>
            </Card>
          </Col>
        ))}
      </Row>)}
    </div>
  );
};

export default QuotaUsage;
